import React from 'react';
import * as utils from '../date_utils';
import ArrowDownSlimIcon from '../../../common/icons/arrow-down-slim.svg';

export default class CalendarHeader extends React.Component {
    shouldComponentUpdate(nextProps) {
        return !utils.isSameMonth(this.props.currentMonth, nextProps.currentMonth);
    }

    renderDayNames(currentWeekStart) {
        return [0, 1, 2, 3, 4, 5, 6].map(offset => {
            const day = utils.addDays(utils.cloneDate(currentWeekStart), offset);
            const localeData = utils.getLocaleData(day);
            const weekDayName = this.props.useWeekdaysShort
                ? utils.getWeekdayShortInLocale(localeData, day)
                : utils.getWeekdayMinInLocale(localeData, day);
            return (
                <th key={offset} className="dayname">
                    {weekDayName}
                </th>
            );
        });
    }

    render() {
        const firstinterval = this.props.currentMonth;
        const currentWeekStart = utils.getStartOfWeek(
            utils.getStartOfMonth(utils.cloneDate(firstinterval))
        );
        return (
            <thead className="header">
                <tr>
                    <td>
                        <button className="prev" onClick={this.props.onPrevMonth}>
                            <ArrowDownSlimIcon />
                        </button>
                    </td>
                    <td colSpan="5" className="label">
                        {firstinterval.format('MMMM YYYY')}
                    </td>
                    <td>
                        <button className="next" onClick={this.props.onNextMonth}>
                            <ArrowDownSlimIcon />
                        </button>
                    </td>
                </tr>
                <tr>{this.renderDayNames(currentWeekStart)}</tr>
            </thead>
        );
    }
}
